import template from "./hb-onboard.mjs";
import { render } from "lit-html";
import { Drawer } from "flowbite";
import type { DrawerOptions, DrawerInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";
import { loadYouTube } from "../../global";

import Training1 from "../../../models/Training1.json";
import Training2 from "../../../models/Training2.json";
const training1: any = Training1;
const training2: any = Training2;

export class HbOnboard extends HTMLElement {
    private drawer: DrawerInterface;
    private onboard: HTMLElement;
    private skip1: HTMLButtonElement;
    private skip2: HTMLButtonElement;

    private intro1: HTMLElement;
    private training1: HTMLElement;
    private tasks1: HTMLOListElement;
    private show1: HTMLButtonElement;
    private hide1: HTMLButtonElement;

    private intro2: HTMLElement;
    private training2: HTMLElement;
    private tasks2: HTMLOListElement;
    private show2: HTMLButtonElement;
    private hide2: HTMLButtonElement;

    constructor() {
        super();
        render(template(null), this);

        this.onboard = this.querySelector("#hb-onboard")!;
        this.skip1 = this.querySelector("#hb-onboard-skip1")!;
        this.skip2 = this.querySelector("#hb-onboard-skip2")!;

        this.intro1 = this.querySelector("#hb-onboard-intro1")!;
        this.training1 = this.querySelector("#hb-onboard-training1")!;
        this.tasks1 = this.querySelector("#hb-onboard-training1-tasks")!;
        this.show1 = this.querySelector("#hb-onboard-show1")!;
        this.hide1 = this.querySelector("#hb-onboard-hide1")!;

        this.intro2 = this.querySelector("#hb-onboard-intro2")!;
        this.training2 = this.querySelector("#hb-onboard-training2")!;
        this.tasks2 = this.querySelector("#hb-onboard-training2-tasks")!;
        this.show2 = this.querySelector("#hb-onboard-show2")!;
        this.hide2 = this.querySelector("#hb-onboard-hide2")!;

        const options: DrawerOptions = {
            placement: "right",
            backdrop: true,
            bodyScrolling: false,
            edge: false,
            edgeOffset: "",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30",
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                //console.log("drawer is shown");
            },
            onToggle: () => {
                //console.log("drawer has been toggled");
            }
        };

        const instanceOptions: InstanceOptions = {
            id: "hb-onboard",
            override: true
        };

        this.drawer = new Drawer(this.onboard, options, instanceOptions);
    }

    connectedCallback() {
        //this.renderTraining(1);
        //this.renderTraining(2);

        this.show1.addEventListener("click", () => {
            window.localStorage.setItem("training-1", "true");
            window.location.hash = "#/onboard/training-1";
        });

        this.show2.addEventListener("click", () => {
            window.localStorage.setItem("training-2", "true");
            window.location.hash = "#/onboard/training-2";
        });

        this.hide1.addEventListener("click", () => {
            window.localStorage.setItem("training-1", "false");
            window.location.hash = "#/onboard/start";
        });

        this.hide2.addEventListener("click", () => {
            window.localStorage.setItem("training-2", "false");
            window.location.hash = "#/onboard/begin";
        });

        this.skip1.addEventListener("click", () => {});

        this.skip2.addEventListener("click", () => {});
    }

    show(page: string) {
        switch (page) {
            case "start":
                this.intro1.classList.remove("hidden");
                this.training1.classList.add("hidden");
                this.intro2.classList.add("hidden");
                this.training2.classList.add("hidden");
                break;
            case "training-1":
                this.renderTraining(1);
                this.intro1.classList.add("hidden");
                this.training1.classList.remove("hidden");
                this.intro2.classList.add("hidden");
                this.training2.classList.add("hidden");
                break;
            case "begin":
                this.intro1.classList.add("hidden");
                this.training1.classList.add("hidden");
                this.intro2.classList.remove("hidden");
                this.training2.classList.add("hidden");
                break;
            case "training-2":
                this.renderTraining(2);
                this.intro1.classList.add("hidden");
                this.training1.classList.add("hidden");
                this.intro2.classList.add("hidden");
                this.training2.classList.remove("hidden");
                break;
            default:
                window.location.hash = "#";
        }
        loadYouTube(this);
        this.drawer.show();
    }

    hide() {
        this.drawer.hide();
    }

    private renderTraining(trainingNumber: number) {
        let tasks, ol;
        if (trainingNumber === 1) {
            ol = this.tasks1;
            tasks = training1;
        } else {
            ol = this.tasks2;
            tasks = training2;
        }

        ol.innerHTML = "";
        tasks.forEach((task: any, index: number) => {
            const taskNumber = index + 1;
            const li = document.createElement("li");
            li.classList.add(
                "w-full",
                "p-4",
                "rounded-lg",
                task.status === 2
                    ? "text-green-700"
                    : task.status === 1
                      ? "text-blue-700"
                      : "text-gray-900",
                task.status === 2
                    ? "dark:text-green-400"
                    : task.status === 1
                      ? "dark:text-blue-400"
                      : "dark:text-gray-400",
                "border",
                task.status === 2
                    ? "border-green-300"
                    : task.status === 1
                      ? "border-blue-300"
                      : "border-gray-300",
                task.status === 2
                    ? "dark:border-green-800"
                    : task.status === 1
                      ? "dark:border-blue-800"
                      : "bg-gray-100",
                task.status === 2
                    ? "bg-green-50"
                    : task.status === 1
                      ? "bg-blue-100"
                      : "bg-gray-100",
                "dark:bg-gray-800"
            );
            li.role = "alert";

            const a = document.createElement("a");
            a.classList.add("flex", "items-center", "justify-between");
            if (task.status !== 0)
                a.href = `#/video/training-${trainingNumber}-${taskNumber}`;
            const span1 = document.createElement("span");
            span1.textContent = task.title;
            span1.classList.add("sr-only");
            const span2 = document.createElement("span");
            span2.textContent =
                task.status === 2 ? "✅" : task.status === 1 ? "➡️" : "";
            span2.classList.add("font-medium");
            const h3 = document.createElement("h3");
            h3.textContent = `${taskNumber}. ${task.title}`;
            h3.classList.add("font-medium");
            a.append(span1, h3, span2);

            li.append(a);
            ol.append(li);
        });
    }
}
